export function SummeryCards() {
  return (
    <>
      <div className="project-card">
      <div className="header-block">
      <div className="hero-summery-icons">
        <div className="icon-tool-tip icon-padding" data-tooltip="Next.js">
          <img
            className="svg-glow"
            src="/tech_icons/nextjs.svg"
            alt=""
            height="32px"
            width="32px"
          />
        </div>
        <div className="icon-tool-tip icon-padding" data-tooltip="React">
          <img
            className="svg-glow"
            src="/tech_icons/react.svg"
            alt=""
            height="32px"
            width="32px"
          />
        </div>
        <div className="icon-tool-tip icon-padding" data-tooltip="Django" >
        <img className="svg-glow" src="/tech_icons/django.svg" alt="" height="30px" width="30px"/>
        </div>
        </div>
          <h3 className="normal-glow-text">Front-end Development</h3>
        </div>
        <p className="normal-glow-text text-shrink description-spacer">
          Building fast, accessible interfaces with production-grade standards.
        </p>
      </div>
      <div className="project-card">
        <div className="header-block">
          <div className="hero-summery-icons">
        <div className="icon-tool-tip icon-padding" data-tooltip="Python" >
            <img className="svg-glow" src="/tech_icons/python.svg" alt="" height="30px" width="30px"/>
        </div>
        <div className="icon-tool-tip icon-padding" data-tooltip="Node.js">
            <img
                className="svg-glow"
                src="/tech_icons/node.svg"
                alt=""
                height="32px"
                width="32px"
            />
        </div>
        <div className="icon-tool-tip icon-padding" data-tooltip="PostgreSQL">
            <img
                className="svg-glow"
                src="/tech_icons/postgresql.svg"
                alt=""
                height="32px"
                width="32px"
            />
        </div>

          </div>
          <h3 className="normal-glow-text">Back-end Development</h3>
        </div>

        <p className="normal-glow-text text-shrink description-spacer">
          Designing scalable APIs and backends with real-world performance and security in mind.
        </p>
      </div>
      <div className="project-card">
        <div className="header-block">
         <div className="hero-summery-icons">
        <div className="icon-tool-tip icon-padding" data-tooltip="Google Cloud">
            <img
                className="svg-glow"
                src="/tech_icons/cloud.svg"
                alt=""
                height="32px"
                width="32px"
            />
        </div>
        <div className="icon-tool-tip icon-padding" data-tooltip="Linux Servers">
            <img
                className="svg-glow"
                src="/tech_icons/linux.svg"
                alt=""
                height="32px"
                width="32px"
            />
        </div>
    
         </div>
          <h3 className="normal-glow-text">Cloud & Infra Engineering</h3>
        </div>

        <p className="normal-glow-text text-shrink description-spacer">
          Deploying secure, high-availability cloud architectures at global scale.
        </p>
      </div>
    </>
  );
}
